import {
  ArticleParagraph1,
  ArticleParagraph2,
  Button,
  IModalWindowProps,
  ModalWindow,
  UIHeading2,
  UIHeading3,
  useDeviceType,
} from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './UnavailableProgramModal.css';
import AgentIcon from './assets/agentIcon.png';
import { NBSP } from '../../constants/symbols';

interface IGoToModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const MODAL_DESKTOP_WIDTH = 648;

export const UnavailableProgramModal: React.FC<IGoToModalProps> = ({ isOpen, onClose }) => {
  const isMobile = useDeviceType() === 'phone';

  const AdaptableHeading = isMobile ? UIHeading3 : UIHeading2;
  const AdaptableParagraph = isMobile ? ArticleParagraph2 : ArticleParagraph1;
  const adaptableButtonProps = isMobile
    ? { fullWidth: true, size: 'M' as const }
    : { fullWidth: false, size: 'XS' as const };
  const adaptableModalProps: Partial<IModalWindowProps> = isMobile
    ? {
        fixed: true,
        height: '100%',
      }
    : {
        fixed: false,
        width: MODAL_DESKTOP_WIDTH,
      };

  return (
    <ModalWindow
      {...adaptableModalProps}
      escape
      outside
      print
      size="M"
      onClose={onClose}
      open={isOpen}
      content={
        <div className={styles['content']}>
          <div className={styles['icon']}>
            <img src={AgentIcon} />
          </div>
          <div className={styles['heading']}>
            <AdaptableHeading textAlign="center">Программа доступна только{NBSP}риелторам</AdaptableHeading>
          </div>
          <div className={styles['description']}>
            <AdaptableParagraph>
              У{NBSP}вас{NBSP}другой тип{NBSP}профиля{NBSP}— пока не{NBSP}можем подключить{NBSP}вас
            </AdaptableParagraph>
          </div>
        </div>
      }
      footer={
        <div className={styles['footer']}>
          <Button {...adaptableButtonProps} onClick={onClose}>
            Понятно
          </Button>
        </div>
      }
    />
  );
};
